import axios from 'axios'

const myApi = axios.create({
  baseURL: process.env.VUE_APP_URL_BACKEND + 'api/',
  withCredentials: true, // <- Habilitar para manejar cookies del back
  headers: {
    'X-Custom-Header': 'CustomHeader1',
  }
})

let isRefreshing = false
let pendingResolvers = []

function queueRetry(cb) {
  return new Promise(resolve => pendingResolvers.push(() => resolve(cb())))
}
function flushQueue() {
  pendingResolvers.forEach(fn => fn())
  pendingResolvers = []
}

myApi.interceptors.response.use(
  res => res,
  async (error) => {
    const { config, response } = error
    if (!response) throw error

    const original = config
    const is401 = response.status === 401

    const url = original?.url || ''
    const isEcom = url.includes('/ecommerce/') || url.includes('ecommerce/')
    const isRefresh = url.includes('/ecommerce/refresh') || url.endsWith('ecommerce/refresh')

    if (!is401 || !isEcom || isRefresh) {
      throw error
    }

    try {
      if (isRefreshing) {
        return queueRetry(() => myApi(original))
      }
      isRefreshing = true
      await myApi.post('ecommerce/refresh')
      flushQueue()
      return myApi(original)
    } catch (e) {
      flushQueue()
      throw e
    } finally {
      isRefreshing = false
    }
  }
)

export default myApi
